import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { InputBlocker } from "./InputBlocker";

export class FullscreenInputBlocker extends InputBlocker {
    private canvasScaler: ICanvasScaler;

    public constructor(canvasScaler: ICanvasScaler) {
        super();
        this.canvasScaler = canvasScaler;
        this.layout();
    }

    private layout(): void {
        this.width = this.canvasScaler.referenceWidth;
        this.height = this.canvasScaler.referenceHeight;
    }
}